import { RenderWarning } from './index'

export function Warnings ({ children, publish, resolve, pageData, error, collapsed }) {
  return (
    <>
      {publish && (
        <RenderWarning
          pageData={pageData}
          resolve={resolve}
          error={error}
        />
      )}
      {children}
      {publish && pageData.items.length > 4 && !collapsed && (
        <RenderWarning
          pageData={pageData}
          resolve={resolve}
        />
      )}
    </>
  )
}
